//@flow
import appSagas from './app.sagas';

export default () => [...appSagas];
